import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class CustomerService {
    static getCustomers(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`customers?filter=${qs}`, pageNumber));
    }
    static fetchCustomer(oid) {
        return lastValueFrom(BaseService.get(`customers/${oid}`));
    }
    static saveCustomer(dto) {
        return lastValueFrom(BaseService.save(`customers`, dto));
    }
    static deleteCustomer(oid) {
        return lastValueFrom(BaseService.delete(`customers/${oid}`));
    }
    static searchCustomerCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`customers-search-dropdown/${selfId}?search=${qs}`));
    }
    // ----------------------------------------------------------------------
    // Stats
    // ----------------------------------------------------------------------
    static fetchCustomerStats(oid) {
        return lastValueFrom(BaseService.get(`customers-stats/${oid}`));
    }
}
